import React, { ReactNode, createContext, useEffect, useState } from 'react';
import DongSoundFile from '../../assets/wav/swiftly-610.wav';

interface ServiceRequestSoundContextValue {
  handlePlaySound: () => void;
  handleStopSound: () => void;
}

export const ServiceRequestSoundContext = createContext<ServiceRequestSoundContextValue>({ handlePlaySound: () => {}, handleStopSound: () => {} });
export const ServiceRequestSoundContextProvider = ({ children }: { children: ReactNode }) => {
  let [play_sound, setPlaySound] = useState(false);

  const handlePlaySound = async () => {
    try {
      const audio = document.getElementById('audio-service-request-sound');
      if (audio instanceof HTMLAudioElement && audio !== null) {
        await audio.play();
      }
    } catch (error) {
      console.error('Error playing audio:', error);
    }
  };

  useEffect(() => {
    if (play_sound) {
      handlePlaySound();
    }
  }, [play_sound]);

  const handleStopSound = () => {
    setPlaySound(false);
  };

  return (
    <>
      <ServiceRequestSoundContext.Provider
        value={{
          handlePlaySound,
          handleStopSound,
        }}
      >
        <audio id="audio-service-request-sound">
          <source src={DongSoundFile} type="audio/wav" />
        </audio>

        {children}
      </ServiceRequestSoundContext.Provider>
    </>
  );
};
